/* ============================================
   444 MAISON — THEME JS
   ============================================ */

document.addEventListener('DOMContentLoaded', function () {

  /* ---------- CART DRAWER ---------- */
  const cartDrawer = document.getElementById('CartDrawer');
  const cartOverlay = document.getElementById('CartOverlay');
  const cartToggle = document.getElementById('CartToggle');
  const cartClose = document.getElementById('CartClose');

  function openCart() {
    cartDrawer?.classList.add('open');
    cartOverlay?.classList.add('open');
  }
  function closeCart() {
    cartDrawer?.classList.remove('open');
    cartOverlay?.classList.remove('open');
  }

  cartToggle?.addEventListener('click', openCart);
  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  /* ---------- ADD TO CART (AJAX) ---------- */
  document.querySelectorAll('[data-add-to-cart-form]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const formData = new FormData(form);
      const btn = form.querySelector('[type="submit"]');
      const originalText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Ajout...'; btn.disabled = true; }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          refreshCartDrawer();
          if (btn) { btn.textContent = '✓ Ajouté'; }
          openCart();
          setTimeout(function () {
            if (btn) { btn.textContent = originalText; btn.disabled = false; }
          }, 1800);
        })
        .catch(function () {
          if (btn) { btn.textContent = originalText; btn.disabled = false; }
        });
    });
  });

  function updateCartCount(count) {
    const el = document.getElementById('CartCount');
    if (el) el.textContent = count;
  }

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2 }) + ' €';
  }

  function renderDrawerItems(cart) {
    const container = document.getElementById('CartItemsContainer');
    if (!container) return;
    if (cart.item_count === 0) {
      container.innerHTML = '<div class="cart-empty">Votre panier est vide.</div>';
      return;
    }
    container.innerHTML = cart.items.map(function (item) {
      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? '<div class="cart-item-variant">' + item.variant_title + '</div>' : '';
      return '<div class="cart-item" data-key="' + item.key + '">' +
        '<img src="' + item.image + '" alt="' + item.product_title + '">' +
        '<div class="cart-item-info">' +
        '<div class="cart-item-name">' + item.product_title + '</div>' +
        variant +
        '<div class="cart-item-bottom">' +
        '<div class="cart-item-price">' + formatMoney(item.final_line_price) + '</div>' +
        '<button type="button" class="cart-item-remove" data-drawer-remove>Retirer ✕</button>' +
        '</div></div></div>';
    }).join('');
    bindDrawerRemoveButtons();
  }

  function removeDrawerItem(key, rowEl) {
    rowEl.classList.add('removing');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        const subtotal = document.getElementById('CartSubtotal');
        if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
        renderDrawerItems(cart);
      })
      .catch(function () {
        rowEl.classList.remove('removing');
      });
  }

  function bindDrawerRemoveButtons() {
    document.querySelectorAll('#CartItemsContainer .cart-item').forEach(function (row) {
      const btn = row.querySelector('[data-drawer-remove]');
      btn?.addEventListener('click', function () {
        removeDrawerItem(row.dataset.key, row);
      });
    });
  }
  bindDrawerRemoveButtons();

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const subtotal = document.getElementById('CartSubtotal');
        if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
        renderDrawerItems(cart);
      });
  }

  /* ---------- SIZE SELECTOR (product card + product page) ---------- */
  document.querySelectorAll('.pd-sizes, .sizes').forEach(function (group) {
    group.querySelectorAll('.pd-size, .size').forEach(function (btn) {
      if (btn.disabled) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        group.querySelectorAll('.pd-size, .size').forEach(function (b) {
          b.classList.remove('active');
        });
        btn.classList.add('active');

        const form = group.closest('form');
        const hiddenInput = form?.querySelector('[data-variant-input], [name="id"]');
        if (hiddenInput && btn.dataset.variantId) {
          hiddenInput.value = btn.dataset.variantId;
        }

        const priceDisplay = form?.querySelector('[data-price-display]');
        if (priceDisplay && btn.dataset.variantPrice) {
          const price = parseInt(btn.dataset.variantPrice, 10);
          const compare = parseInt(btn.dataset.variantCompare || '0', 10);
          if (compare > price) {
            priceDisplay.innerHTML = '<span class="old">' + formatMoney(compare) + '</span><span class="sale">' + formatMoney(price) + '</span>';
          } else {
            priceDisplay.textContent = formatMoney(price);
          }
        }
      });
    });
  });

  /* ---------- QUANTITY STEPPER ---------- */
  document.querySelectorAll('.pd-quantity').forEach(function (wrap) {
    const input = wrap.querySelector('.pd-qty-input');
    const minus = wrap.querySelector('[data-qty-minus]');
    const plus = wrap.querySelector('[data-qty-plus]');
    minus?.addEventListener('click', function () {
      const v = Math.max(1, parseInt(input.value || '1', 10) - 1);
      input.value = v;
    });
    plus?.addEventListener('click', function () {
      const v = parseInt(input.value || '1', 10) + 1;
      input.value = v;
    });
  });

  /* ---------- ACCORDION (product details) ---------- */
  document.querySelectorAll('.pd-accordion-header').forEach(function (header) {
    header.addEventListener('click', function () {
      header.closest('.pd-accordion-item').classList.toggle('open');
    });
  });

  /* ---------- PRODUCT GALLERY THUMBS ---------- */
  document.querySelectorAll('.product-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      const mainImg = document.querySelector('.product-main-img');
      if (mainImg && thumb.dataset.fullSrc) {
        mainImg.src = thumb.dataset.fullSrc;
      }
      document.querySelectorAll('.product-thumb').forEach(function (t) {
        t.classList.remove('active');
      });
      thumb.classList.add('active');
    });
  });

  /* ---------- SCROLL REVEAL ---------- */
  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) e.target.classList.add('visible');
    });
  }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });

  document.querySelectorAll('.reveal').forEach(function (el, i) {
    el.style.transitionDelay = (i % 3) * 80 + 'ms';
    observer.observe(el);
  });

});
